import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { Input } from '../../Components/UI/Input';
import { otpVerificationSchema } from '../../Schema';
import AlertModal from '../AlertModal';
import classes from './EmailVerificationCode.module.css';
import ModalAction from '../ModalAction';
import OtpInput from '../../Components/UI/OtpInput';
import clsx from 'clsx';
import useSignup from '../../Features/useSignup';
import { useSelector } from 'react-redux';
import useProfile from '../../Features/useProfile';
const OtpVerificationModal = ({ onSubmit, setShow, data, show, loading }) => {
  const email = useSelector((state) => state?.commonReducer?.email);
  const { verifyOtpForUpdateEmail, otpVerified } = useProfile();
  const formik = useFormik({
    initialValues: {
      otp: ''
    },
    validationSchema: otpVerificationSchema,
    onSubmit: () => {
      if (typeof onSubmit === 'function')
        onSubmit({}, () => {
          resetForm();
          setShow(false);
        });
    }
  });

  const [timeLeft, setTimeLeft] = useState(10);
  const { values, errors, touched, handleSubmit, setFieldValue, setFieldTouched, resetForm } =
    formik;
  // Initialize Formik

  const handleResendOtp = () => {
    // gener
    resetForm();
    setTimeLeft(30);
  };
  let timer;
  useEffect(() => {
    if (timeLeft > 0) {
      timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [timeLeft]);

  useEffect(() => {
    if (values.otp?.length === 6) verifyOtpForUpdateEmail({ otpCode: values?.otp }, onCancel);
  }, [values?.otp]);
  const onCancel = () => {
    clearTimeout(timer);

    // setFieldValue('otp', '');
  };
  const isButtonDisabled =
    Object.keys(errors).length === 0 && Object.keys(touched).length > 0 && timeLeft > 0;

  let timeAndResendContent;
  if (otpVerified) {
    timeAndResendContent = null;
  } else if (!otpVerified && timeLeft > 0) {
    timeAndResendContent = (
      <span className={clsx(classes.indicator)}>{`Resend OTP in ${timeLeft} seconds`}</span>
    );
  } else {
    timeAndResendContent = (
      <span className={clsx(classes.indicator, classes.resendAction)} onClick={handleResendOtp}>
        Resend Now
      </span>
    );
  }
  return (
    <AlertModal title={'Verification Code'} show={show} setShow={setShow} actions={false}>
      <form onSubmit={handleSubmit}>
        <p className={classes.note}>We are automatically detecting a SMS send to you Email</p>
        <OtpInput
          id={classes.ggg}
          value={values.otp}
          setter={(value) => {
            setFieldValue('otp', value);
            setFieldTouched('otp', true, false);
          }}
          error={touched?.otp && errors.otp}
          isVerified={otpVerified}
        />
        {timeAndResendContent}
        <ModalAction
          disabled={!otpVerified}
          type="submit"
          isApiCall={loading}
          className={classes.actions}
          onCancel={() => {
            if (typeof onCancel === 'function') onCancel();
          }}
        />
      </form>
    </AlertModal>
  );
};

export default OtpVerificationModal;
